module.exports = __webpack_public_path__ + "static/img/8.0ce3e51.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/zh/8.png
// module id = syra
// module chunks = 0